export default __webpack_public_path__ + "static/schedule-therapist-2b2e798c9c419cd447503558d618e169.webp";